module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.transition) ? _c('b-modal', {
    attrs: {
      "visible": _vm.showModal === 'transitionOrderConfirm',
      "lazy": true
    },
    on: {
      "show": _vm.initModal,
      "hidden": _vm.hideModal
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-title"
    },
    slot: "modal-title"
  }, [(_vm.order) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Подтвердите действие для заказа №" + _vm._s(_vm.order.id))]) : _vm._e()]), _vm._v(" "), (_vm.loading) ? _c('loading', {
    attrs: {
      "size": 3,
      "message": "Подождите..."
    }
  }) : _c('div', [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h3', [_vm._v(_vm._s(_vm.transition.name) + "?")]), _vm._v(" "), (_vm.transition.code == 'accept') ? _c('span', [_vm._v("\n                Укажите предполагаемую сумму заказ-наряда.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.transition.code == 'complete') ? _c('span', [_vm._v("\n                Подтвердите сумму заказ-наряда которую заплатил клиент.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.transition.code == 'calculate') ? _c('span', [_vm._v("\n                Заполните данные. Они необходимы для расчетов.\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.transition.code === 'accept' || _vm.transition.code === 'complete' || _vm.transition.code == 'calculate') ? _c('form', {
    attrs: {
      "сlass": "form-horizontal"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.setTransition($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.sum.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "sum-input"
    }
  }, [_vm._v("Общая сумма заказ-наряда")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sum),
      expression: "sum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "rel": "focusThis",
      "id": "sum-input",
      "placeholder": "Сумма по заказ-наряду"
    },
    domProps: {
      "value": (_vm.sum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.sum = $event.target.value
      }, function($event) {
        _vm.$v.sum.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.sum.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Сумма заказ-наряда дожна быть больше 0")]) : _vm._e()])]), _vm._v(" "), (_vm.transition.code === 'calculate') ? _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.profit.$error
    }
  }, [_c('label', {
    staticClass: "col-6 form-control-label",
    attrs: {
      "for": "profit-input"
    }
  }, [_vm._v("Комиссия с заказа")]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profit),
      expression: "profit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "profit-input",
      "placeholder": "Комиссия по заказ-наряду"
    },
    domProps: {
      "value": (_vm.profit)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.profit = $event.target.value
      }, function($event) {
        _vm.$v.profit.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.profit.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Комиссия должна быть больше 0")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.transition.code === 'calculate') ? _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.$v.comment.$error
    }
  }, [_c('label', {
    staticClass: "col-12 form-control-label",
    attrs: {
      "for": "comment-input"
    }
  }, [_vm._v("Как был сделан расчет (прикрепится комментарий к заказу)")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "comment-input",
      "placeholder": "Пожалуйста распишите как можно подробнее как был произведен расчет, стоимость закупки оборудования, работы установщика и т.д.",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }, function($event) {
        _vm.$v.comment.$touch()
      }]
    }
  }), _vm._v(" "), (_vm.$v.comment.$error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Описание обязательно должно быть заполнено")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(!_vm.loading) ? _c('b-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal($event)
      }
    }
  }, [_vm._v("Ничего не делать")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('b-btn', {
    class: _vm.transition.class,
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setTransition($event)
      }
    }
  }, [_vm._v("Подтвердить")]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1dba252c"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalTransitionOrderConfirm.vue
// module id = 1004
// module chunks = 1